<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="20">
          <el-form :inline="true">
            <el-form-item>
              <el-button type="primary" @click="add">添加权限</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-tree
        class="custom-tree"
        :data="records"
        :props="props"
        node-key="id"
        default-expand-all
        :expand-on-click-node="false">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.label }}</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="() => append(data)">
            添加子权限
          </el-button>
          <el-button
            type="text"
            size="mini"
            @click="() => batch(data)">
            添加增删改查权限
          </el-button>
          <el-button
            type="text"
            size="mini"
            @click="() => edit(data)">
            修改
          </el-button>
          <el-button
            type="text"
            size="mini"
            @click="() => remove(node, data)">
            删除
          </el-button>
        </span>
      </span>
    </el-tree>
    </el-main>
    <el-dialog
      :title="`${modalTit}权限`"
      :visible.sync="formVisible"
      :close-on-click-modal="false"
      width="600px">
      <el-form ref="formData" :model="formData" label-width="100px">
        <el-form-item label="权限名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="权限标识" prop="label">
          <el-input v-model="formData.label"></el-input>
        </el-form-item>
        <el-form-item label="绑定菜单" prop="label">
          <el-cascader v-model="formData.menuIds" :options="menus" :props="menuProps" @change="onChangeMenu"></el-cascader>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="formData.sort"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onSave">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'Permissions',
  data () {
    return {
      filterData: {
        name: ''
      },
      formData: {
        name: '',
        label: '',
        sort: 1
      },
      props: {
        label: 'name',
        children: 'children'
      },
      records: [],
      currentRow: null,
      currentChecked: null,
      formVisible: false,
      modalTit: '',
      menus: [],
      menuProps : {
        label: 'name',
        value: 'id',
        multiple: true,
        expandTrigger: 'hover',
        emitPath: false
      }
    }
  },
  mounted () {
    this.getList()
    this.getMenus()
  },
  methods: {
    getList () {
      const loading = this.$loading({
        lock: true,
        text: '数据加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.5)'
      })
      request.get(`permissions`).then(res => {
        this.records = res.data
        loading.close()
      })
    },
    getMenus(){
      request.get('menus').then(res=>{
        this.menus = res.data
      })
    },
    add () {
      this.modalTit = '添加'
      this.formVisible = true
    },
    edit (row) {
      this.modalTit = '编辑'
      this.formData = row
      this.formVisible = true
    },
    onCancel () {
      this.formData = {
        name: '',
        label: '',
        sort: 1
      }
      this.currentRow = null
      this.formVisible = false
    },
    onSave () {
      if (this.currentRow) {
        this.formData.parent_id = this.currentRow.id
      }
      if (this.formData.id) {
        request.put(`permissions/${this.formData.id}`, this.formData).then(() => {
          this.formData = {
            name: '',
            label: '',
            sort: 1
          }
          this.getList()
          this.formVisible = false
        })
      } else {
        request.post(`permissions`, this.formData).then(() => {
          this.formData = {
            name: '',
            label: '',
            sort: 1
          }
          this.getList()
          this.formVisible = false
        })
      }
      this.currentRow = null
    },
    append (data) {
      this.currentRow = data
      this.formVisible = true
      if (!this.currentRow.children) {
        this.$set(this.currentRow, 'children', [])
      }
    },
    batch (data) {
      this.currentRow = data
      const loading = this.$loading({
        lock: true,
        text: '数据加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.5)'
      })
      request.get(`permissions/${data.id}/batch`).then(() => {
        loading.close()
        this.getList()
      })
    },
    remove (node, data) {
      this.$confirm('确定删除此项吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        const parent = node.parent
        const children = parent.data.children || parent.data
        const index = children.findIndex(d => d.id === data.id)
        children.splice(index, 1)
        request.delete(`permissions/${data.id}`)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    ParentChange (data, checked) {
      if (checked.checkedKeys.length > 0) {
        if (this.currentChecked) {
          this.$refs.tree.setChecked(this.currentChecked, false)
        }
        this.currentChecked = data.id
      } else {
        this.currentChecked = null
      }
    },
    onChangeMenu (val) {
      console.log(val)
    }
  }
}
</script>

<style scoped>
.el-aside {
  border-right: 1px solid #ddd;
}
.list-group li {
  cursor: pointer;
  padding: 0 10px;
}
.list-group li:hover, .list-group li.active {
  background-color: #ecf5ff;
}
.custom-tree .custom-tree-node{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
